<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">Hakkımızda</p>
    <h1 class="h1" style="margin-top:16px">Öğretmek bir iş, <span class="vurgu">hatırlatmak başka</span>.</h1>
    <p class="giris-p">pratiu, kazanım temelli öğrenmeyi hedefleyen ve bilgiyi taze tutmayı iş edinen bir eğitim platformu. Türkiye'nin eğitim ekosisteminde kurumdan öğrenciye kadar tüm paydaşların aynı veriye baktığı bir yer kurmaya çalışıyoruz.</p>
  </div>
</div>

<div class="sar bol">
  <div class="aciklama">
    <div>
      <span class="etiket">Neden kurduk</span>
      <h2 class="h2" style="margin:14px 0 18px">Konu bitti, defter kapandı, bilgi gitti.</h2>
      <p>Türkiye'de bir öğrenci sekizinci sınıfa gelene kadar binlerce kazanımla karşılaşır. Her biri işlenir, ölçülür ve büyük ölçüde unutulur. LGS ya da YKS haftalarında ise aynı kazanımlar sıfırdan öğrenilmeye çalışılır.</p>
      <p>Bu tekrarın bir bilimi var: aralıklı tekrar. Doğru soruyu doğru gün sormak, aynı soruyu on kez sormaktan daha etkili. Bunu tek tek elle yapmak ise bir öğretmenin gününe sığmaz.</p>
      <p>pratiu tam olarak bu işi otomatikleştirir. Öğretmenin zamanını takvim tutmaya değil, öğretmeye ayırmasını istiyoruz.</p>
    </div>
    <div>
      <span class="etiket">Değerlerimiz</span>
      <div style="margin-top:18px;display:flex;flex-direction:column;gap:1px;background:var(--cizgi);border:1px solid var(--cizgi)">
        <div style="background:var(--kagit);padding:20px"><h4 class="h4">Sürekli öğrenme</h4><p class="soluk" style="font-size:14.5px;margin-top:6px">Başarı tek bir sınav günü değil, bilgiyi güncel tutma alışkanlığıdır.</p></div>
        <div style="background:var(--kagit);padding:20px"><h4 class="h4">Ölçülebilirlik</h4><p class="soluk" style="font-size:14.5px;margin-top:6px">Hissiyat değil kazanım verisi. Rapor, karar verilebilir olmalı.</p></div>
        <div style="background:var(--kagit);padding:20px"><h4 class="h4">Öğretmenin kararı</h4><p class="soluk" style="font-size:14.5px;margin-top:6px">Yapay zekâ soru üretir, öğretmen onaylar. Sıra hiçbir zaman tersine dönmez.</p></div>
        <div style="background:var(--kagit);padding:20px"><h4 class="h4">Veri sorumluluğu</h4><p class="soluk" style="font-size:14.5px;margin-top:6px">Çocuk verisiyle çalışıyoruz. KVKK bizim için asgari eşik, hedef değil.</p></div>
      </div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div><h2 class="h2">Birlikte çalışalım mı?</h2><p>Kurum, okul ya da bireysel öğretmen — nereden başlayacağınızı konuşalım.</p></div>
    <a class="btn kirmizi" routerLink="/contact">Bize yazın <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
